import {Controller, useForm} from "react-hook-form";
import {useEffect} from "react";
import Poster from "../../display/serials/Poster";
import {EditFranchiseSerials} from "./EditFranchiseSerials";

export function EditFranchise(props) {
    const {user, franchise, onSaveClicked, onDeleteClicked} = props;

    const {register, handleSubmit, watch, reset, control} = useForm({
        defaultValues: franchise || {
            isActive: true,
            name: '',
            nameOriginal: '',
            slug: '',
            description: '',
            posterUrl: ''
        }
    });

    useEffect(() => {
        if (franchise) {
            reset(franchise);
        }
    }, [franchise, reset]);

    const labelStyle = {display: 'block', marginBottom: '5px', fontWeight: '600', fontSize: '14px', color: '#4b5563'};
    const inputStyle = {
        width: '100%',
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #d1d5db',
        marginBottom: '15px',
        outline: 'none',
        boxSizing: 'border-box'
    };

    return (
        <div style={{padding: '10px'}}>
            <form onSubmit={handleSubmit(onSaveClicked)}>
                <div style={{display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: '30px'}}>
                    <div>
                        {/*todo add flag into db if need*/}
                       {/* <div style={{marginBottom: '20px'}}>
                            <Controller
                                name="isActive"
                                control={control}
                                render={({field}) => (
                                    <ToggleField label={field.value ? "Активна" : "Неактивна"} value={field.value}
                                                 onChange={field.onChange} color="#10b981"/>
                                )}
                            />
                        </div>*/}

                        <label style={labelStyle}>Назва (UA)</label>
                        <input {...register('name')} style={inputStyle} placeholder="Наприклад: Психопаспорт"/>

                        <label style={labelStyle}>Оригінальна назва</label>
                        <input {...register('nameOriginal')} style={inputStyle} placeholder="Psycho-Pass"/>

                        <label style={labelStyle}>Slug</label>
                        <input {...register('slug')} style={inputStyle} placeholder="psycho-pass (якщо порожнє - ств. автоматично)"/>

                        <label style={labelStyle}>Опис</label>
                        <textarea {...register('description')}
                                  style={{...inputStyle, minHeight: '120px', resize: 'vertical'}}/>

                    </div>

                    <div style={{
                        backgroundColor: '#f9fafb',
                        padding: '20px',
                        borderRadius: '12px',
                        border: '1px dashed #d1d5db',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '15px'
                    }}>
                        <div>
                            <label style={labelStyle}>URL основного постера</label>
                            <input {...register('posterUrl')} style={inputStyle}/>
                            <Poster link={watch('posterUrl')}/>
                        </div>

                        <div style={{borderTop: '1px solid #e5e7eb', pt: '15px'}}>
                            <label style={labelStyle}>URL плейсхолдера</label>
                            <input {...register('placeholderPosterUrl')} style={inputStyle}/>
                            <div style={{width: '100px'}}>
                                <Poster link={watch('placeholderPosterUrl')}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                {/* SERIALS */}
                {franchise?.id && (
                    <EditFranchiseSerials user={user} franchiseId={franchise.id}/>
                )}
                </div>

                <div style={{
                    marginTop: '30px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderTop: '2px solid #f3f4f6',
                    paddingTop: '20px'
                }}>
                    {franchise?.id ? (
                        <button
                            type="button"
                            onClick={() => onDeleteClicked(franchise)}
                            style={{
                                color: '#ef4444',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontWeight: '600',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px'
                            }}
                        >
                            🗑️ Видалити франшизу
                        </button>
                    ) : <div/>}

                    <button
                        type="submit"
                        style={{
                            padding: '12px 40px',
                            backgroundColor: '#4f46e5',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            boxShadow: '0 4px 6px -1px rgba(79, 70, 229, 0.4)'
                        }}
                    >
                        Зберегти франшизу
                    </button>
                </div>
            </form>
        </div>
    );
}

const ToggleField = ({value, onChange, label, color}) => (
    <div onClick={() => onChange(!value)}
         style={{display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer'}}>
        <div style={{
            width: '36px',
            height: '18px',
            backgroundColor: value ? color : '#d1d5db',
            borderRadius: '20px',
            position: 'relative',
            transition: '0.3s'
        }}>
            <div style={{
                width: '14px',
                height: '14px',
                backgroundColor: '#fff',
                borderRadius: '50%',
                position: 'absolute',
                top: '2px',
                left: value ? '20px' : '2px',
                transition: '0.3s'
            }}/>
        </div>
        <span style={{fontSize: '13px', fontWeight: '600', color: '#374151'}}>{label}</span>
    </div>
);